var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_c('van-loading',{attrs:{"size":"16px"}},[_vm._v("加载中...")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }